"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

exports.__esModule = true;
exports.QueryCache = void 0;

var _utils = require("./utils");

var _query = require("./query");

var _notifyManager = require("./notifyManager");

var _subscribable = require("./subscribable"); // CLASS


var QueryCache = /*#__PURE__*/function (_subscribable$Subscri) {
  _inherits(QueryCache, _subscribable$Subscri);

  var _super = _createSuper(QueryCache);

  function QueryCache(config) {
    var _this;

    _classCallCheck(this, QueryCache);

    _this = _super.call(this);
    _this.config = config || {};
    _this.queries = [];
    _this.queriesMap = {};
    return _this;
  }

  _createClass(QueryCache, [{
    key: "build",
    value: function build(client, options, state) {
      var _options$queryHash;

      var queryKey = options.queryKey;
      var queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0, _utils.hashQueryKeyByOptions)(queryKey, options);
      var query = this.get(queryHash);

      if (!query) {
        query = new _query.Query({
          cache: this,
          logger: client.getLogger(),
          queryKey: queryKey,
          queryHash: queryHash,
          options: client.defaultQueryOptions(options),
          state: state,
          defaultOptions: client.getQueryDefaults(queryKey),
          meta: options.meta
        });
        this.add(query);
      }

      return query;
    }
  }, {
    key: "add",
    value: function add(query) {
      if (!this.queriesMap[query.queryHash]) {
        this.queriesMap[query.queryHash] = query;
        this.queries.push(query);
        this.notify({
          type: 'added',
          query: query
        });
      }
    }
  }, {
    key: "remove",
    value: function remove(query) {
      var queryInMap = this.queriesMap[query.queryHash];

      if (queryInMap) {
        query.destroy();
        this.queries = this.queries.filter(function (x) {
          return x !== query;
        });

        if (queryInMap === query) {
          delete this.queriesMap[query.queryHash];
        }

        this.notify({
          type: 'removed',
          query: query
        });
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      var _this2 = this;

      _notifyManager.notifyManager.batch(function () {
        _this2.queries.forEach(function (query) {
          _this2.remove(query);
        });
      });
    }
  }, {
    key: "get",
    value: function get(queryHash) {
      return this.queriesMap[queryHash];
    }
  }, {
    key: "getAll",
    value: function getAll() {
      return this.queries;
    }
  }, {
    key: "find",
    value: function find(arg1, arg2) {
      var _ref = (0, _utils.parseFilterArgs)(arg1, arg2),
          _ref2 = _slicedToArray(_ref, 1),
          filters = _ref2[0];

      if (typeof filters.exact === 'undefined') {
        filters.exact = true;
      }

      return this.queries.find(function (query) {
        return (0, _utils.matchQuery)(filters, query);
      });
    }
  }, {
    key: "findAll",
    value: function findAll(arg1, arg2) {
      var _ref3 = (0, _utils.parseFilterArgs)(arg1, arg2),
          _ref4 = _slicedToArray(_ref3, 1),
          filters = _ref4[0];

      return Object.keys(filters).length > 0 ? this.queries.filter(function (query) {
        return (0, _utils.matchQuery)(filters, query);
      }) : this.queries;
    }
  }, {
    key: "notify",
    value: function notify(event) {
      var _this3 = this;

      _notifyManager.notifyManager.batch(function () {
        _this3.listeners.forEach(function (listener) {
          listener(event);
        });
      });
    }
  }, {
    key: "onFocus",
    value: function onFocus() {
      var _this4 = this;

      _notifyManager.notifyManager.batch(function () {
        _this4.queries.forEach(function (query) {
          query.onFocus();
        });
      });
    }
  }, {
    key: "onOnline",
    value: function onOnline() {
      var _this5 = this;

      _notifyManager.notifyManager.batch(function () {
        _this5.queries.forEach(function (query) {
          query.onOnline();
        });
      });
    }
  }]);

  return QueryCache;
}(_subscribable.Subscribable);

exports.QueryCache = QueryCache;